<template>
    <v-container>
        <v-card>
            <v-card-title>
                {{$t('mainNumber')}} - {{ username }}
                <v-spacer></v-spacer>
                <v-dialog v-model="changePass" width="500">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" small color="primary">{{$t('changeAdminPassword')}}</v-btn>
                    </template>
                    <v-card>
                        <v-card-title primary-title>
                            {{$t('changeAdminPassword')}}
                        </v-card-title>
                        <v-card-text>
                            <v-text-field :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show3 ? 'text' : 'password'" @click:append="show3 = !show3" v-model="oldPassword"
                                :label="$t('currentPassword')"></v-text-field>
                            <v-text-field :append-icon="show4 ? 'mdi-eye' : 'mdi-eye-off'"
                                :type="show4 ? 'text' : 'password'" @click:append="show4 = !show4" v-model="newPassword"
                                :label="$t('newPassword')"></v-text-field>
                            {{ changeStatus }}
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" text @click="changePassword">{{$t('changePassword')}}</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-title>
        </v-card>
        <v-card style="margin-top:10px;">
            <v-card-title primary-title>
                {{$t('moreNumbers')}}
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-list>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>{{$t('secondaryNumbers')}}</v-list-item-title>
                                    <v-list-item-subtitle>
                                        <p v-for="did of secondary" :key="did">{{$t('number')}}: {{ did.did }}<br>{{ did.usage }}</p>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                    <v-col>
                        <v-list>
                            <v-list-item>
                                <v-list-item-content>
                                    <v-list-item-title>{{$t('callerIds')}} <v-btn to="addSpeicel" color="primary"
                                            x-small outlined>{{$t('addCallerId')}}</v-btn>
                                    </v-list-item-title>
                                    <v-list-item-subtitle>
                                        <p v-for="callerId of callerIds" :key="callerId">{{ callerId }}</p>
                                    </v-list-item-subtitle>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <v-card style="margin-top:10px;">
            <v-card-title>
                {{$t('userDetails')}}:
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="sendData">
                    <v-icon left>mdi-content-save-edit</v-icon> {{$t('saveChanges')}}
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-text-field v-model="username" outlined :label="$t('mainNumber')" disabled value="phone.number">
                </v-text-field>
                <v-row>
                    <v-col cols="6">
                        <v-text-field v-model="name" outlined :label="$t('customerName')"></v-text-field>
                    </v-col>
                    <v-col cols="6">
                        <v-text-field v-model="email" outlined :label="$t('emailAddress')" type="email"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field v-model="organization" outlined :label="$t('organization')"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field v-model="contactName" outlined :label="$t('contactName')"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field v-model="phones" outlined :label="$t('phone')" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field v-model="fax" outlined :label="$t('fax')" type="number"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field v-model="invoiceName" outlined :label="$t('invoiceName')"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field v-model="invoiceAddress" outlined :label="$t('invoiceAddress')"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show1 ? 'text' : 'password'" @click:append="show1 = !show1" v-model="accessPassword"
                            outlined :label="$t('accessPassword')"></v-text-field>
                    </v-col>
                    <v-col cols="6" style="margin-top:-20px">
                        <v-text-field :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                            :type="show2 ? 'text' : 'password'" @click:append="show2 = !show2" v-model="recordPassword"
                            outlined :label="$t('recordPassword')"></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
            </v-card-actions>
        </v-card>
        <v-snackbar v-model="showStatus">
            {{ status }}
        </v-snackbar>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        username: '',
        name: '',
        email: '',
        organization: '',
        contactName: '',
        phones: '',
        fax: '',
        invoiceName: '',
        invoiceAddress: '',
        accessPassword: '',
        recordPassword: '',
        showStatus: false,
        status: '',
        changePass: false,
        oldPassword: '',
        newPassword: '',
        changeStatus: '',
        show1: false,
        show2: false,
        show3: false,
        show4: false,
        secondary: [],
        callerIds: [],
    }),
    methods: {
        loadData() {
            (async () => {
                const body = { token: sessionStorage.token };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetCustomerData`, body);
                this.username = response.data.mainDid;
                this.name = response.data.name;
                this.email = response.data.email;
                this.organization = response.data.organization;
                this.contactName = response.data.contactName;
                this.phones = response.data.phones;
                this.fax = response.data.fax;
                this.invoiceName = response.data.invoiceName;
                this.invoiceAddress = response.data.invoiceAddress;
                this.accessPassword = response.data.accessPassword;
                this.recordPassword = response.data.recordPassword;
                this.secondary = response.data.secondary_dids;
                this.callerids = response.data.callerIds;
                if (response.data.accessPassword === "null" | response.data.recordPassword === "null") {
                    this.accessPassword = '';
                    this.recordPassword = '';
                } else {
                    this.accessPassword = response.data.accessPassword;
                    this.recordPassword = response.data.recordPassword;
                }
            })();
        },
        sendData() {
            (async () => {
                const body = { token: sessionStorage.token, username: this.username, name: this.name, email: this.email, organization: this.organization, contactName: this.contactName, phones: this.phones, fax: this.fax, invoiceName: this.invoiceName, invoiceAddress: this.invoiceAddress, accessPassword: this.accessPassword, recordPassword: this.recordPassword };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/SetCustomerDetails`, body);
                this.showStatus = true;
                if (response.data.message === "ok") {
                    this.status = this.$t('saveSuccess')
                } else {
                    this.status = this.$t('error')
                }
            })();
        },
        async changePassword() {
            const body = { token: sessionStorage.token, password: this.oldPassword, newPassword: this.newPassword };
            const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/SetPassword`, body);
            if (sessionStorage.getItem('users') == 'true') {
                const body = { password: this.newPassword };
                const response = await axios.patch('/api/users/setSystemPassword', body, { headers: { 'Authorization': `Bearer ${sessionStorage.uToken}` } });
                if (response.data.status === "SUCCESS") {
                    this.changeStatus = this.$t('passwordChangeSuccess')
                    setTimeout(location.href = "/login", 3000);
                } else {
                    this.changeStatus = this.$t('passwordChangeError')
                }
            }
            else {
                this.showStatus = true;
                if (response.data.message === "ok") {
                    this.changeStatus = this.$t('passwordChangeSuccess')
                    setTimeout(location.href = "/login", 3000);
                } else {
                    this.changeStatus = this.$t('passwordChangeError')
                }
            }
        },
    },
    beforeMount() {
        this.loadData();
    },
}
</script>